import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { useDueDateChangeLog } from "../hooks/useDueDateChangeLog";
import "./DueDateChangeBadge.css";

function fmt(d) {
  if (!d) return "—";
  const dt = new Date(d);
  if (isNaN(dt)) return String(d);
  return dt.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
}

function fmtTs(d) {
  if (!d) return "";
  const dt = new Date(d);
  if (isNaN(dt)) return "";
  return dt.toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });
}

export default function DueDateChangeBadge({ entityType, entityId }) {
  const { history, count, loading } = useDueDateChangeLog(entityType, entityId);
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const popRef = useRef(null);
  const [popPos, setPopPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (!open) return;
    function handler(e) {
      if (
        btnRef.current && !btnRef.current.contains(e.target) &&
        popRef.current && !popRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [open]);

  if (loading || count === 0) return null;

  const handleOpen = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!open) {
      const rect = btnRef.current.getBoundingClientRect();
      setPopPos({
        top: rect.bottom + window.scrollY + 6,
        left: rect.left + window.scrollX,
      });
    }
    setOpen((v) => !v);
  };

  return (
    <>
      <button
        ref={btnRef}
        className="ddcb-pill"
        onClick={handleOpen}
        title="Due date change history"
        type="button"
      >
        {count}
      </button>

      {open && createPortal(
        <div
          ref={popRef}
          className="ddcb-popup"
          style={{ top: popPos.top, left: popPos.left }}
        >
          <div className="ddcb-popup-header">
            <span>Due Date Changes</span>
            <button className="ddcb-popup-close" onClick={() => setOpen(false)}>✕</button>
          </div>
          <ul className="ddcb-popup-list">
            {history.map((row) => (
              <li key={row.id} className="ddcb-comment">
                <div className="ddcb-comment-avatar">
                  {(row.changed_by_name || "?").charAt(0).toUpperCase()}
                </div>
                <div className="ddcb-comment-body">
                  <div className="ddcb-comment-meta">
                    <span className="ddcb-comment-name">{row.changed_by_name || "Unknown"}</span>
                    <span className="ddcb-comment-time">{fmtTs(row.changed_at)}</span>
                  </div>
                  <div className="ddcb-comment-dates">
                    <span className="ddcb-comment-from">{fmt(row.from_date)}</span>
                    <span className="ddcb-comment-arrow">→</span>
                    <span className="ddcb-comment-to">{fmt(row.to_date)}</span>
                  </div>
                  {row.reason && (
                    <div className="ddcb-comment-reason">"{row.reason}"</div>
                  )}
                </div>
              </li>
            ))}
          </ul>
        </div>,
        document.body
      )}
    </>
  );
}
